import Layer from '@/models/layer'
import vectorUtils from '@src/utils/vectorUtils'
import utils from '@utils/genUUID'

export default class VectorLayer extends Layer {
  constructor (obj, needMap = false) {
    super()
    if (needMap) {
      Object.assign(this, {
        _name: obj.name,
        _type: obj.type,
        _feature: obj.feature ? this.setProperties(obj.feature) : undefined,
        _isResult: obj.isResult,
        _vectorType: obj.vectorType,
        _properties: obj.properties ? obj.properties : [],
        _filters: obj.filters ? obj.filters : undefined,
        _isAOI: obj.isAOI ? obj.isAOI : false,
        _AOIId: obj.AOIId ? obj.AOIId : undefined,
        _resultId: obj.resultId,
        _bounds: (obj.feature && obj.feature.features.length > 0) ? vectorUtils.geomToBBox(obj.feature) : obj.bounds ? obj.bounds : undefined,
        _showFeatureCount: false,
        _displayType: obj.displayType ? obj.displayType : 'line',
        _listProperties: obj.listProperties,
        _featureCount: obj.feature ? obj.feature.features.length : undefined,
        _paint: obj.style ? obj.style : {},
        _sourceId: obj.sourceId,
        _styleType: obj.styleType,
        _downloadUrl: obj.downloadUrl ? obj.downloadUrl : undefined,
        _rasterVal: obj.rasterVal ? obj.rasterVal : undefined,
        _fileName: obj.file_name ? obj.file_name : undefined,
        _workspaceId: obj.workspaceId ? obj.workspaceId : undefined,
        _labels: obj.labels ? obj.labels : undefined,
        _label: obj.label ? obj.label : undefined,
        _isOpenClass: false,
        _isExpand: !!obj.labels,
        _isGeoJson: obj.isGeoJson,
        _typeOfVector: obj.typeOfVector,
        _listValue: this.getListValue(),
        _listLabels: obj.listLabels ? obj.listLabels : []
      })
    } else {
      Object.assign(this, obj)
    }
  }

  get allowStyle () {
    return true
    // return !this._labels
  }
  get isVector () {
    return true
  }
  get isGeoJson () {
    return this._isGeoJson
  }
  setProperties (feature) {
    feature.features.forEach(val => {
      val.properties['eofId'] = utils.getUUID()
    })
    return feature
  }
  getMapboxLayer () {
    const source = this._sourceId ? this._sourceId : {
      'type': 'geojson',
      'data': this._feature
    }
    let layout = {
      'visibility': 'visible'
    }
    if (this._type === 'symbol' && this._displayType === 'text') {
      layout = {...layout,
        ...{ 'text-field': ['get', 'name'],
          'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
          'text-radial-offset': 0.5,
          'text-justify': 'auto'}}
    }
    return {
      'id': this._id,
      'name': this._name,
      'type': this._type,
      'source': source,
      'layoutRight': this._layoutRight,
      'layoutLeft': this._layoutLeft,
      'layout': layout,
      'paint': this._paint
    }
  }
  getListValue () {
    let listValue = []
    if (this.labels) {
      this.labels.forEach(val => {
        listValue.push({
          name: val.name,
          minvalue: val.resterValue,
          color: val.color
        })
      })
    }
    return listValue
  }
  get listValue () {
    return this._listValue
  }
  set listValue (newValue) {
    this._listValue = newValue
  }
  get displayType () {
    return this._displayType
  }
  get vectorType () {
    return this._vectorType
  }
  get fileName () {
    return this._fileName
  }
  get downloadUrl () {
    return this._downloadUrl
  }
  get rasterVal () {
    return this._rasterVal
  }
  get feature () {
    return this._feature
  }
  set feature (newValue) {
    this._feature = newValue
  }
  set featureCount (newValue) {
    this._featureCount = newValue
  }
  get featureCount () {
    return this._featureCount
  }
  set properties (newValue) {
    this._properties = newValue
  }
  get properties () {
    return this._properties
  }
  set filters (newValue) {
    this._filters = newValue
  }
  get filters () {
    return this._filters
  }
  get showFeatureCount () {
    return this._showFeatureCount
  }
  set showFeatureCount (newValue) {
    this._showFeatureCount = newValue
  }
  get bounds () {
    return this._bounds
  }
  set bounds (newValue) {
    this._bounds = newValue
  }
  get listProperties () {
    return this._listProperties
  }
  set listProperties (newValue) {
    this._listProperties = newValue
  }
  get resultId () {
    return this._resultId
  }
  get isResult () {
    return this._isResult
  }
  get labels () {
    return this._labels
  }
  set labels (newValue) {
    this._labels = newValue
  }
  get label () {
    return this._label
  }
  set label (newValue) {
    this._label = newValue
  }

  get isOpenClass () {
    return this._isOpenClass
  }

  set isOpenClass (newValue) {
    this._isOpenClass = newValue
  }
  get isExpand () {
    return this._isExpand
  }

  set isExpand (newValue) {
    this._isExpand = newValue
  }

  get typeOfVector () {
    return this._typeOfVector
  }

  set typeOfVector (newValue) {
    this._typeOfVector = newValue
  }

  get styleType () {
    return this._styleType
  }

  set styleType (newValue) {
    this._styleType = newValue
  }

  get listLabels () {
    return this._listLabels
  }

  set listLabels (newValue) {
    this._listLabels = newValue
  }
}



// WEBPACK FOOTER //
// ./src/models/vector-layer.js